var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.445 18.6584C9.72821 17.616 8.11138 16.4166 6.61536 15.0754C3.03596 11.8537 1.50017 8.88711 1.5 6.26279L11.445 18.6584ZM11.445 18.6584C13.1617 17.6161 14.7784 16.4168 16.2744 15.0757C19.854 11.8538 21.3898 8.88717 21.39 6.26279L11.445 18.6584ZM20.4574 3.43288C21.0628 4.25209 21.3896 5.24376 21.39 6.26236H1.5C1.50038 5.24376 1.82722 4.25209 2.43257 3.43288C3.038 2.61354 3.89013 2.00986 4.86388 1.71043C5.83763 1.411 6.88173 1.4316 7.84291 1.76919C8.8041 2.10679 9.63176 2.74361 10.2044 3.58618L11.445 5.41153L12.6856 3.58618C13.2582 2.74361 14.0859 2.10679 15.0471 1.76919C16.0083 1.4316 17.0524 1.411 18.0261 1.71043C18.9999 2.00986 19.852 2.61354 20.4574 3.43288Z",
    stroke: "#FCC436",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeart);
export default __webpack_public_path__ + "static/media/whiteHeart.35a2f29d6b038b61934f84ffdf265bfe.svg";
export { ForwardRef as ReactComponent };